import React from "react";
import { NavLink } from "react-router-dom";
import { Compass, Sparkles, ExternalLink, KeyRound, LogOut } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

const RIJ = "w-full min-h-[48px] flex items-center gap-3 px-3 rounded-md text-[15px] font-medium text-zinc-800 hover:bg-zinc-100 transition-colors";

const Rij = ({ icon: Icon, children, rechts, ...p }) => (
  <button type="button" className={RIJ} {...p}><Icon className="h-5 w-5 text-zinc-500" /><span className="flex-1 text-left">{children}</span>{rechts}</button>
);

const Link = ({ href, testid, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={RIJ}>
    <ExternalLink className="h-5 w-5 text-zinc-500" /><span className="flex-1">{children}</span>
  </a>
);

// v18 A1: "Meer" op de telefoon — dezelfde iconen en labels als het menu, plus links en account.
export const MeerSheet = ({ open, onOpenChange, user, items, counts, onbHasNew, wachtwoordHint, onWachtwoord, onUitloggen }) => {
  const sluit = () => onOpenChange(false);
  const event = (naam) => () => { sluit(); window.dispatchEvent(new CustomEvent(naam)); };
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" data-testid="meer-sheet" className="rounded-t-2xl p-4 max-h-[85vh] overflow-y-auto" style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}>
        <SheetHeader className="text-left mb-2">
          <SheetTitle className="font-heading font-black">Meer</SheetTitle>
          <SheetDescription className="sr-only">De overige onderdelen van de cockpit</SheetDescription>
        </SheetHeader>
        {wachtwoordHint && (
          <button type="button" data-testid="hint-change-password" onClick={() => { sluit(); onWachtwoord(); }}
            className="w-full min-h-[44px] mb-2 flex items-center gap-2.5 px-3 rounded-[10px] bg-amber-50 border border-amber-200 text-[13px] font-semibold text-amber-900 text-left">
            <span className="h-2 w-2 rounded-full bg-amber-400 shrink-0" />Stel een eigen wachtwoord in
          </button>
        )}
        <div className="space-y-0.5">
          {items.map((n) => {
            const c = n.countKey ? counts[n.countKey] || 0 : 0;
            return (
              <NavLink key={n.key} to={n.to} onClick={sluit} data-testid={`meer-${n.key}`}
                className={({ isActive }) => `${RIJ} ${isActive ? "bg-zinc-100 font-semibold text-zinc-950" : ""}`}>
                <n.icon className="h-5 w-5 text-zinc-500" /><span className="flex-1">{n.label}</span>
                {c > 0 && <span data-testid={`meer-badge-${n.key}`} title={n.badgeTitle ? `${n.badgeTitle}: ${c}` : undefined} className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-rose-600 text-white text-[11px] font-bold font-mono">{c}</span>}
              </NavLink>
            );
          })}
          <div className="h-px bg-zinc-200 my-2" />
          <Rij icon={Compass} data-testid="meer-intro" onClick={event("onboarding:open-intro")}>Intro</Rij>
          <Rij icon={Sparkles} data-testid="meer-nieuw" onClick={event("onboarding:open-changelog")}
            rechts={onbHasNew && <span data-testid="meer-nieuw-dot" className="h-2 w-2 rounded-full bg-rose-500" />}>Nieuw</Rij>
          {user.role !== "bedrijfsleider" && (<>
            <Link href="https://daily-ops.nl" testid="nav-link-daily-ops">Daily Ops</Link>
            <Link href="https://truckwash-ops.nl" testid="nav-link-hub">Hub</Link>
          </>)}
          <div className="h-px bg-zinc-200 my-2" />
          <Rij icon={KeyRound} data-testid="meer-wachtwoord" onClick={() => { sluit(); onWachtwoord(); }}>Wachtwoord</Rij>
          <Rij icon={LogOut} data-testid="meer-uitloggen" onClick={() => { sluit(); onUitloggen(); }}>Uitloggen</Rij>
        </div>
      </SheetContent>
    </Sheet>
  );
};
